/**
 * Describes whether a holiday is used for an employee
 * for a full day, a half day or not.
 */
export enum HolidayExtent {
    None = 0,
    Half = 1,
    Full = 2
}